import { useMemo } from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import styles from '../SearchBar.module.scss'
import Tag from 'components/tag/Tag'
import HighlightedText from '../highlighted-text/HighlightedText'
import { routes } from 'utils/routes'
import { CldImage } from 'next-cloudinary'
import { SearchItemProps } from 'components/encyclopedia/search-bar/types'

const SearchItem = ({ item, query, selected }: SearchItemProps) => {
  const destination = useMemo(
    () => routes(item.locale, '', [item.category?.slug, item.subcategory?.slug, item.slug]).encyclopediaArticle,
    [item.locale, item.category.slug, item.subcategory.slug, item.slug]
  )

  return (
    <li className={classNames(styles['search-item-wrapper'], { [styles.selected]: selected })}>
      <Link passHref href={destination} className={styles['search-item']} aria-selected={selected}>
        <figure className={styles.thumbnail}>
          <CldImage
            width={40}
            height={40}
            src={item.thumbnail.data?.attributes.formats?.thumbnail?.url}
            placeholder="blur"
            alt=""
            blurDataURL={item.thumbnail.data?.attributes.formats?.thumbnail?.url}
          />
        </figure>
        <div className={styles.content}>
          {item.category && (
            <div className={styles['tag-container']}>
              <Tag color={item.category?.color} isSmall>
                {item.category.title}
              </Tag>
            </div>
          )}
          <HighlightedText text={item.title} highlight={query} />
        </div>
      </Link>
    </li>
  )
}

export default SearchItem
